import { STRIPE_VALIDATE_PROMOTION_CODE_API, noop } from '@aloft/toolkit-shared';
import { Button, Flex, SimpleInput } from '@aloft/toolkit-sui';

import { useState } from 'react';

import { useValidatePromotionCode } from '../../../../hooks/api/toolkitComponents.ts';
import { useToaster } from '../../../../hooks/useToaster/useToaster.tsx';

type Props = {
  onSuccess: (promoCode: string) => void;
};

export const PromoCodeForm = ({ onSuccess }: Props) => {
  const toast = useToaster();

  const [promoCode, setPromoCode] = useState('');
  const validatePromoCode = useValidatePromotionCode();

  const handleSubmit = async (event: React.FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (!promoCode.length) return;

    const response = await validatePromoCode.mutateAsync({
      body: STRIPE_VALIDATE_PROMOTION_CODE_API.POST.REQUEST.BODY.parse({
        promotionCode: promoCode,
      }),
    });

    const { isValid } = STRIPE_VALIDATE_PROMOTION_CODE_API.POST.RESPONSE.parse(response);
    if (isValid) {
      onSuccess(promoCode);
      setPromoCode('');
    } else {
      toast({
        id: 'invalid-promo-code',
        title: 'Invalid promo code',
        type: 'warning',
      });
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <Flex alignItems="flex-end" gap="4px">
        <SimpleInput
          type="text"
          label="Promo code"
          labelTypographyVariant="h4"
          value={promoCode}
          onChange={(e) => setPromoCode(e.target.value)}
          size="sm"
        />
        <Button
          __dangerDoNotUseSx={{ height: '32px' }}
          text="Apply"
          onClick={noop}
          type="submit"
          size="sm"
          disabled={validatePromoCode.isPending}
          isLoading={validatePromoCode.isPending}
        />
      </Flex>
    </form>
  );
};
